export default "__VITE_ASSET__C4KVeAc5__"